import React from "react";
//import PropTypes from 'prop-types';

import {
    ListItem as BaseListItem,
    MenuItems as BaseMenuItems,
} from "playground/cms/views/Resources";
import { useData } from "state/hooks";
import DateDiff from "components/DateDiff";

export function ListItem(props) {
    const {} = props;
    const data = useData(props);
    const label = data?.resource?.resource?.code_part;
    return (
        <BaseListItem {...props} primaryText={label} indicateInactive={false}>
            <DateDiff value={data?.synced_at} />
        </BaseListItem>
    );
}

ListItem.propTypes = {};

ListItem.defaultProps = {};

export default ListItem;
